import { useEffect, useState } from 'react'
import { Link, usePage } from '@inertiajs/react'
import type { SharedProps } from '@/types'
import BrandMark from './BrandMark'

export type NavbarLabels = {
  features: string
  pricing: string
  faq: string
  dashboard_cta: string
  login_cta: string
}

export default function Navbar({ labels }: { labels: NavbarLabels }) {
  const { auth } = usePage<SharedProps>().props
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollToTop = () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' })
  }

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 bg-paper/[0.86] backdrop-blur-[8px] border-b-2 transition-colors duration-200 ${
        scrolled ? 'border-ink' : 'border-transparent'
      }`}
    >
      <div className="max-w-[1080px] mx-auto px-[22px] h-16 flex items-center justify-between">
        <button
          type="button"
          onClick={scrollToTop}
          className="flex items-center gap-2.5 p-0 bg-transparent font-body font-extrabold text-lg text-ink tracking-tight cursor-pointer"
        >
          <BrandMark />
          Kego&nbsp;<span className="text-flame">Fûté</span>
        </button>
        <div className="flex items-center gap-6">
          {/* No section links: the page is four blocks long, so scrolling beats navigating.
              The labels stay in NavbarLabels and in the locales — the sections they pointed
              to are kept on disk and could come back (spec 2026-07-29, decision 2). */}
          <Link
            href={auth.user ? '/dashboard' : '/session/new'}
            className="inline-flex items-center gap-2 font-bold text-[15px] text-paper bg-ink hover:bg-[#3d2312] border-2 border-ink rounded-[12px] px-4 py-2 transition-all hover:-translate-y-0.5"
          >
            {auth.user ? labels.dashboard_cta : labels.login_cta}
          </Link>
        </div>
      </div>
    </nav>
  )
}
